module.exports = __webpack_public_path__ + "static/media/24.747fb46d.jpeg";